import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-folder-fill 265",
  "use": "icon-folder-fill 265-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-folder-fill 265\"><path d=\"M460.650667 192a64 64 0 0 1 62.485333 50.133333l3.093333 13.866667H789.333333a64 64 0 0 1 64 64v448a64 64 0 0 1-64 64H234.666667a64 64 0 0 1-64-64V256a64 64 0 0 1 64-64h225.984zM746.666667 640H277.333333v64h469.333334v-64z m42.666666-320H540.437333l9.493334 42.666667H789.333333v-42.666667z\" p-id=\"19343\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol